import { IModuleDuration } from 'app/library/module/interfaces/module-duration.interface';
import { ICourseCatalogPostingCourseOfferingQuery } from '../interfaces/course-catalog-posting-course-offering.query.interface';
import { UserExtendedAttributeWithValue } from 'app/projects/user/src/lib/models/user-attribute-with-value';

// @dynamic
export class CourseCatalogCourseOffering {
    attributes: UserExtendedAttributeWithValue[];
    bookedAsParticipant: boolean;
    duration: IModuleDuration;

    constructor(query: ICourseCatalogPostingCourseOfferingQuery) {
        this.attributes = query.attributes ? query.attributes.map((query) => new UserExtendedAttributeWithValue(query.attribute, query.value)) : [];
        this.bookedAsParticipant = query.booked_as_participant;
        for (const property in query.duration) {
            if (query?.duration[property]) {
                this.duration = query?.duration;
            }
        }
    }
}
